module.exports = __webpack_public_path__ + "static/overview-shop-1@2x-477ca265b61f01ab9881b9a96244d095.jpg";